export default __webpack_public_path__ + "static/sprite-24c973e07f2c1ebc11a3fc72b3e43b8e.svg";